import * as yup from 'yup';

export const newsSchema = yup.object().shape({
  title: yup.string().required(),
  text: yup.string().required(),
  link: yup.string().url('Invalid URL'),
  media: yup.mixed().required(),
});
